import { AxiosError } from 'axios';
import { userApi } from 'entities/user';
import { sum } from 'lodash';
import { fromDecimals } from 'shared';
import { error, request, success } from 'shared/api';
import { call, put, takeLatest } from 'typed-redux-saga';

import { userActions } from '../reducer';

const REWARDS_DECIMALS = 8;

export function* getAirdropInfoSaga({
  type,
  payload: { address, web3Provider },
}: ReturnType<typeof userActions.getAirdropInfo>) {
  try {
    yield put(request(type));
    try {
      const airdropInfoResponse = yield* call(userApi.getAirdropInfo, address);
      const rewardsArr = airdropInfoResponse.data;
      const totalRewards = sum(rewardsArr.map((rewardsInfo: any) => rewardsInfo.rewards));

      yield put(userActions.updateAirdropInfo({ totalAmount: Number(fromDecimals(totalRewards, REWARDS_DECIMALS)) }));
    } catch (err) {
      if (err instanceof AxiosError && err.response?.status === 404) {
        yield put(userActions.updateAirdropInfo({ totalAmount: 0 }));
      } else {
        throw err;
      }
    }

    yield put(success(type));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    yield put(error(type));
  }
}

export default function* listener() {
  yield takeLatest(userActions.getAirdropInfo.type, getAirdropInfoSaga);
}
